export const deploymentNeGD = "NeGD";

export const NeGD = {
    Cadre: "AWW",
    Kb: "WCD",
    Approach: "PAGE_SEARCH"
}